import { Abwesenheitsantraege } from '@/domain/navigation/benachrichtigungen/types/AbwesenheitsAntraege';
import { Dokumente } from '@/domain/navigation/benachrichtigungen/types/Dokumente';
import { FehlendeArbeitszeiten } from '@/domain/navigation/benachrichtigungen/types/FehlendeArbeitszeiten';
import { Fristen } from '@/domain/navigation/benachrichtigungen/types/Fristen';
import { Krankmeldungen } from '@/domain/navigation/benachrichtigungen/types/Krankmeldungen';
import { Personalfragebogen } from '@/domain/navigation/benachrichtigungen/types/Personalfragebogen';
import { SchichttauschAntrag } from '@/domain/navigation/benachrichtigungen/types/SchichttauschAntrag';

export class Arbeitsbereich {
  constructor({
    id,
    name,
    markierung,
  }: {
    id: string;
    name: string;
    markierung: string;
  }) {
    this.id = id;
    this.name = name;
    this.markierung = markierung;
  }
  id: string;
  name: string;
  markierung: string;
}

export class Mitarbeiter {
  constructor({
    vorname,
    nachname,
    bildUrl,
    id,
    istExtern = false,
    arbeitsbereich,
    arbeitnehmertyp,
  }: {
    vorname: string;
    nachname: string;
    bildUrl: string;
    id: string;
    istExtern?: boolean;
    arbeitsbereich?: Arbeitsbereich;
    arbeitnehmertyp?: string;
  }) {
    this.vorname = vorname;
    this.nachname = nachname;
    this.bildUrl = bildUrl;
    this.id = id;
    this.istExtern = istExtern;
    this.arbeitsbereich = arbeitsbereich;
    this.arbeitnehmertyp = arbeitnehmertyp;
  }
  vorname: string;
  nachname: string;
  bildUrl?: string;
  istExtern?: boolean;
  arbeitsbereich: Arbeitsbereich;
  arbeitnehmertyp?: string;
  id: string;
}

export class Benachrichtigungen {
  constructor({
    abwesenheitsantraege,
    fehlendeArbeitszeiten,
    fristen,
    krankmeldungen,
    dokumente,
    personalfragebogen,
    schichttauschAntraege,
  }: {
    fehlendeArbeitszeiten: FehlendeArbeitszeiten[];
    abwesenheitsantraege: Abwesenheitsantraege[];
    fristen: Fristen[];
    krankmeldungen: Krankmeldungen[];
    dokumente: Dokumente[];
    personalfragebogen: Personalfragebogen[];
    schichttauschAntraege: SchichttauschAntrag[];
  }) {
    this.fehlendeArbeitszeiten = fehlendeArbeitszeiten;
    this.abwesenheitsantraege = abwesenheitsantraege;
    this.fristen = fristen;
    this.krankmeldungen = krankmeldungen;
    this.dokumente = dokumente;
    this.personalfragebogen = personalfragebogen;
    this.schichttauschAntraege = schichttauschAntraege;
  }

  fehlendeArbeitszeiten: FehlendeArbeitszeiten[];
  abwesenheitsantraege: Abwesenheitsantraege[];
  fristen: Fristen[];
  krankmeldungen: Krankmeldungen[];
  dokumente: Dokumente[];
  personalfragebogen: Personalfragebogen[];
  schichttauschAntraege: SchichttauschAntrag[];
}

export enum Markierung {
  BLACK = 'BLACK',
  BLUE = 'BLUE',
  BROWN = 'BROWN',
  CYAN = 'CYAN',
  DARKBLUE = 'DARKBLUE',
  DARKGREEN = 'DARKGREEN',
  DARKRED = 'DARKRED',
  GOLD = 'GOLD',
  GRAY = 'GRAY',
  GREEN = 'GREEN',
  LIGHTBLUE = 'LIGHTBLUE',
  LIGHTGRAY = 'LIGHTGRAY',
  LIGHTGREEN = 'LIGHTGREEN',
  LILA = 'LILA',
  MAGENTA = 'MAGENTA',
  ORANGE = 'ORANGE',
  PINK = 'PINK',
  RED = 'RED',
  ROSE = 'ROSE',
  VIOLETT = 'VIOLETT',
  YELLOW = 'YELLOW',
}

export enum Abwesenheitsgrund {
  ARBEITSUNFALL = 'Arbeitsunfall',
  ARZTBESUCH = 'Arztbesuch',
  AUSGLEICHSRUHEZEITENTAG = 'Ausgleichsruhezeitentag',
  BESCHAEFTIGUNGSVERBOT = 'Beschaeftigungsverbot',
  BEZAHLTERARBEITSFREIERTAG = 'BezahlterArbeitsfreierTag',
  BILDUNG = 'Bildung',
  EURENTE = 'EURente',
  ELTERNZEIT = 'Elternzeit',
  FEHLTUNENTSCHULDIGT = 'FehltUnentschuldigt',
  FEIERTAG = 'Feiertag',
  FEIERTAGSAUSGLEICH = 'Feiertagsausgleich',
  FEIERTAGSAUSGLEICHDYNAMISCH = 'FeiertagsausgleichDynamisch',
  FERIENTAG = 'Ferientag',
  FREI = 'Frei',
  FREISTELLUNG = 'Freistellung',
  GUTTAGMINUS = 'GuttagMinus',
  GUTTAGPLUS = 'GuttagPlus',
  KOMPENSATIONSTAG = 'Kompensationstag',
  KRANK = 'Krank',
  KRANKIMFREI = 'KrankImFrei',
  KRANKINKURZARBEIT = 'KrankInKurzarbeit',
  KRANKOHNELOHNFORTZAHLUNG = 'KrankOhneLohnfortzahlung',
  KRANKENGELD = 'Krankengeld',
  KRANKESKIND = 'KrankesKind',
  KUR = 'Kur',
  KURZARBEIT = 'Kurzarbeit',
  LEHRGANG = 'Lehrgang',
  MILITAERZIVILDIENST = 'MilitaerZivildienst',
  MUTTERSCHAFT = 'Mutterschaft',
  MUTTERSCHUTZ = 'Mutterschutz',
  QUARANTAENE = 'Quarantaene',
  QUARANTAENEOHNELFZ = 'QuarantaeneOhneLFZ',
  RUHETAG = 'Ruhetag',
  SCHULE = 'Schule',
  SONDERURLAUB = 'Sonderurlaub',
  UEBERSTUNDENABBAU = 'Ueberstundenabbau',
  UNBEZAHLTERFERIENTAG = 'UnbezahlterFerientag',
  UNBEZAHLTERURLAUB = 'UnbezahlterUrlaub',
  UNFALL = 'Unfall',
  URLAUB = 'Urlaub',
  VATERSCHAFT = 'Vaterschaft',
  WIEDEREINGLIEDERUNG = 'Wiedereingliederung',
  WUNSCHFREI = 'Wunschfrei',
}
